import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const faqs = [{
  q: '¿En qué formato recibo el material?',
  a: 'En PDF, listo para imprimir desde cualquier dispositivo. Sin apps ni suscripciones.'
}, {
  q: '¿Para qué edades sirve?',
  a: 'Para chicos de 2 a 10 años. El material está organizado por franjas de edad para que sea fácil encontrar lo que necesitás.'
}, {
  q: '¿Puedo imprimirlo cuantas veces quiera?',
  a: 'Sí. El PDF es tuyo y podés imprimirlo todas las veces que lo necesités, con distintos chicos o grupos.'
}, {
  q: '¿Funciona para chicos con TEA, TDAH o dislexia?',
  a: 'Sí. Incluye material específico con más estructura visual, secuencias claras y recursos pensados para diversidad funcional. Es un apoyo educativo, no un tratamiento clínico.'
}, {
  q: '¿Las planillas son editables?',
  a: 'Sí. Son editables en Canva / Word / PDF rellenable.'
}, {
  q: '¿Cómo recibo los bonos?',
  a: 'Los bonos llegan junto con el pack principal, en el mismo email de acceso.'
}, {
  q: '¿Cuánto tarda en llegar?',
  a: 'El acceso es inmediato. En minutos recibís el email con el link de descarga.'
}, {
  q: '¿Puedo usarlo en clases virtuales?',
  a: 'Sí. Podés compartir pantalla con las actividades o enviar las fichas en PDF a las familias.'
}, {
  q: '¿Puedo reutilizarlo cada año?',
  a: 'Sí. El material no vence. Lo usás cada ciclo escolar con distintos chicos o grupos.'
}, {
  q: '¿Qué diferencia tiene este pack con otros materiales gratuitos?',
  a: 'Que está organizado como un sistema, no como una colección suelta. Tenés material por área, por edad y por necesidad, más planillas para hacer seguimiento. No es solo "descargar y ver qué pasa".'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 md:py-20 px-4 bg-white" data-id="element-75">
      <div className="max-w-3xl mx-auto" data-id="element-76">
        <h2 className="text-3xl md:text-4xl font-black text-center text-brand-dark mb-8 md:mb-12" data-id="element-77">
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-78">
          {faqs.map((faq, index) => <div key={index} className="border-2 border-gray-100 rounded-xl overflow-hidden shadow-sm" data-id="element-79">
              <button className="w-full px-6 py-5 text-left bg-gray-50 hover:bg-gray-100 transition-colors flex justify-between items-center" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-80">
                <span className="font-bold text-lg text-brand-dark pr-4" data-id="element-81">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUpIcon className="w-6 h-6 text-brand-orange flex-shrink-0" data-id="element-82" /> : <ChevronDownIcon className="w-6 h-6 text-gray-400 flex-shrink-0" data-id="element-83" />}
              </button>

              {openIndex === index && <div className="px-6 py-5 bg-white text-gray-700 text-lg leading-relaxed border-t border-gray-100" data-id="element-84">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}